import react, { useEffect, useMemo, useState } from 'react';
import './formularios.scss'
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel';
import Button from '../../../../../components/Atomsv2/Button/Button';
import Table from '../../../../../components/moleculesv2/Table/Table';
import Card from '../../../../../components/Atomsv2/Card/Card';
import Column from '../../../../../components/moleculesv2/Table/Column';
import Status from '../../../../../components/Atomsv2/Status/Status';
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast';
import { IntegracionProyectos } from '../../integracion';
import Modal from '../../../../../components/Atomsv2/Modal/Modal';
import Input from '../../../../../components/Atomsv2/Input/Input';
import Calendar from '../../../../../components/Atomsv2/Calendar/Calendar';
import Select from '../../../../../components/Atomsv2/Select/Select';
import MultiSelect from '../../../../../components/Atomsv2/MultiSelect/MultiSelect';

const Sprint = ({ open, onClose, data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [addData, setAddData] = useState({
        sprint: null,
        proyecto: '',
        descripcion: '',
        estatus: null,
        fecha_ini: null,
        fecha_fin: null
    });
    const [filtros, setFiltros] = useState({
        estatus: []
    })
    useEffect(() => {
        setFiltros({
            estatus: data.estatus
        })
    }, [data.estatus])

    const getId = (item) => item?.ID ?? item?.value
    const sprintsFiltrados = useMemo(() => {
        const idsEstatus = filtros.estatus.map(getId);

        return data.sprints.filter((proy) =>
            idsEstatus.includes(proy.ID_ESTATUS)
        );
    }, [data.estatus, filtros]);


    const estatusSelect = useMemo(() => data.estatus.map((estatu) => ({ value: estatu.ID, label: estatu.ESTATUS })), [data.estatus]);
    function formatearFecha(fecha) {
        const [fechaParte, horaParte] = fecha.split(' ');
        const [yyyy, MM, dd] = fechaParte.split('-');
        const [HH, mm] = horaParte.split(':');

        return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
    }
    const statusTemplate = (id_estatus, estatus) => {
        const colores = {
            1: 'default',
            2: 'warning',
            3: 'primary',
            4: 'success',
            5: 'error',
        }
        const color = colores[id_estatus] || '#6c757d';
        return (
            <Status severity={color} >{estatus}</Status>
        )
    }
    const handleRowEdit = (newRow, rowIndex) => {
        try {
            setData(prev => ({ 
                ...prev,
                sprints: prev.sprints.map((item, index) => index === rowIndex ? newRow : item)
            }));
            IntegracionProyectos.updateSprint({
                id: newRow.ID,
                id_proyecto: newRow.ID_PROYECTO,
                descripcion: newRow.DESCRIPCION,
                sprint: newRow.SPRINT,
                estatus_id: newRow.ID_ESTATUS,
                fecha_ini: newRow.FECHA_INI,
                fecha_fin: newRow.FECHA_FIN
            });
        }
        catch (error) {
            console.error("Error al actualizar el proyecto:", error);
            addToast("error en la edición", "error", 3000, 'ligth');
        }
    };
    const submit = async () => {
        try {
            if (!addData.descripcion || !addData.estatus || !addData.fecha_ini || !addData.fecha_fin) {
                addToast("Por favor, complete todos los campos", "error", 3000, 'ligth');
                return;
            }
            await IntegracionProyectos.createSprint({
                sprint: addData.sprint,
                descripcion: addData.descripcion,
                id_proyecto: null,
                estatus_id: addData.estatus.value,
                fecha_ini: addData.fecha_ini,
                fecha_fin: addData.fecha_fin
            });
            setData(prev => ({
                ...prev,
                sprints: [...prev.sprints, {
                    ID: prev.sprints.length + 1,
                    SPRINT: addData.sprint,
                    DESCRIPCION: addData.descripcion,
                    ESTATUS: addData.estatus.label,
                    ID_ESTATUS: addData.estatus.value,
                    FECHA_INI: addData.fecha_ini,
                    FECHA_FIN: addData.fecha_fin
                }]
            }));
            setAddData({
                sprint: null,
                proyecto: '',
                descripcion: '',
                estatus: null,
                fecha_ini: null,
                fecha_fin: null
            });
            setOpenAddModal(false);
            addToast("Sprint agregado exitosamente", "success", 3000, 'ligth');


        }
        catch (error) {
            console.error("Error al agregar el proyecto:", error);
            addToast("Error al agregar el proyecto", "error", 3000, 'ligth');
        }
    }
    const headerTemplate = <div>
        <MultiSelect
            placeholder='Filtro por ESTATUS'
            label={"Estatus"}

            options={data.estatus}
            value={filtros.estatus}
            onChange={(e) => { setFiltros(prev => ({ ...prev, estatus: prev.estatus = e })) }}
            mapper={{ name: "ESTATUS", value: "ID" }}
        />
    </div>
    return (
        <SidePanel
            className='proyectos-Sprint'
            open={open}
            onClose={onClose}
            width="50vw"
            title="Sprint"
            subtitle={'Crea o edita un sprint para organizar tus tareas'}
        >
            <div className='header-proyecto-general'>
                <Button icon={"add"} onClick={() => { setOpenAddModal(true) }}></Button>
            </div>

            <Card>
                <Table
                    data={sprintsFiltrados}
                    height='calc(100vh - 270px)'
                    globalFilter
                    onRowEdit={handleRowEdit}
                    responsiveHideColumn
                    header={headerTemplate}
                    labelBuscador={"Por nombre"}
                >
                    <Column
                        header="ID"
                        value="ID"
                        sortable
                    />
                    <Column
                        header="NOMBRE"
                        value="SPRINT"
                        sortable
                    />

                    <Column
                        header="DESCRIPCION"
                        value="DESCRIPCION"
                        edit="text"
                        sortable
                    />
                    <Column
                        header="ESTATUS"
                        value="ID_ESTATUS"
                        editLabelKey="ESTATUS"
                        edit="select"
                        body={(row) => statusTemplate(row.ID_ESTATUS, row.ESTATUS)}
                        editOptions={estatusSelect}
                        sortable
                    />
                    <Column
                        header="FECHA INICIO"
                        value="FECHA_INI"
                        edit="datetime"
                        body={(row) => formatearFecha(row.FECHA_INI)}
                        sortable

                    />
                    <Column
                        header="FECHA FIN"
                        value="FECHA_FIN"
                        edit="datetime"
                        body={(row) => formatearFecha(row.FECHA_FIN)}
                        sortable
                    />
                </Table>
            </Card>
            {
                openAddModal == true && (
                    <Modal className='modalProyectoGeneralAgreagr' style={{ zIndex: "1201" }} onClose={() => setOpenAddModal(false)} title="Agregar Sprint">
                        <div className='modal-content-general-proyectos'>

                            <Input label={"NOMBRE"} icon={'description'} value={addData.sprint} onChange={(e) => { setAddData(prev => ({ ...prev, sprint: prev.sprint = e.target.value })) }}></Input>
                            <Input label={"DESCRIPCIÓN"} icon={'description'} value={addData.descripcion} onChange={(e) => { setAddData(prev => ({ ...prev, descripcion: prev.descripcion = e.target.value })) }}></Input>
                            <div className='input-container'>
                                <Calendar withTime label={"FECHA INICIO"} icon={'calendar_month'} value={addData.fecha_ini} onChange={(e) => { setAddData(prev => ({ ...prev, fecha_ini: prev.fecha_ini = e })) }}></Calendar>
                                <Calendar withTime label={"FECHA FIN"} icon={'calendar_month'} value={addData.fecha_fin} onChange={(e) => { setAddData(prev => ({ ...prev, fecha_fin: prev.fecha_fin = e })) }}></Calendar>

                            </div>

                            <Select label={"ESTATUS"}
                                icon={'incomplete_circle'}
                                value={addData.estatus}
                                onChange={(e) => { setAddData(prev => ({ ...prev, estatus: e })) }}
                                options={estatusSelect}
                                mapper={{ name: 'label', value: 'value' }}
                            >
                            </Select>
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                            <Button icon='save' onClick={() => { submit() }}>Guardar</Button>
                        </div>
                    </Modal>
                )
            }


            <ToastContainer toasts={toasts} removeToast={removeToast} />

        </SidePanel >
    )
}
export default Sprint